const settingState = {
	list: []
};

function newSetting(payload) {
	var setting = {}, { key, value } = payload;

	setting[key] = value;

	return setting;
};

module.exports = function settingReducer(state = settingState, {payload, type}) {
	switch (type) {
		case "LOAD_SETTINGS_SUCCESS":
			return Object.assign({}, state, { list: payload });

		case "UPDATE_SETTING_SUCCESS":
			return { list: Object.assign({}, state.list, newSetting(payload))};

		case "UNLOAD_SETTINGS":
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/setting.js